export default __webpack_public_path__ + "static/media/Acolyte's Mask of the Nine Springs.539b458b.jpg";